module.exports = __webpack_public_path__ + "assets/img/8_1724_big.e72a279a.jpg";